export default __webpack_public_path__ + "static/media/nordania-logo.7c0c2f2e.svg";